<template lang="pug">
#serviceDetailView.custom-container(v-if="!loading")
  .section-title Detalle servicio
  b-breadcrumb.breadcrumb(:items="breadcrumbs")
  .table-view
    h3.detail-title Editar {{service.name}}
    hr
    CreateEditForm.mx-3.pt-3(
      :selectedService="selectedService",
      action="edit",
      :hideModal="postSaveForm",
      :makeToast="makeToast")
    ListStates
    ListFolders
    ListNotifications
    ListBusinessByService
    ActiveMonthsForm
</template>
<script>
import CreateEditForm from "../components/service/CreateEditForm";
import ListStates from "../components/service/ServiceStates/ListStates";
import ListFolders from "../components/service/ServiceFolders/ListFolders";
import ListNotifications from "../components/service/ServiceNotification/ListNotifications";
import ListBusinessByService from "../components/service/ListBusinessByService.vue";
import ActiveMonthsForm from "../components/service/ActiveMonthsForm.vue";

import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    CreateEditForm,
    ListFolders,
    ListStates,
    ListNotifications,
    ListBusinessByService,
    ActiveMonthsForm
  },
  data() {
    return {
      selectedService: {},
      loading: true,
      breadcrumbs: [
        {
          text: 'Inicio',
          to: { name: 'Home' }
        },
        {
          text: 'Servicios',
          to: { name: 'Services' }
        },
        {
          text: 'Detalle servicio',
          active:true
        },
      ]
    }
  },
  computed: {
    ...mapGetters(["service"]),
  },
  async created() {
    const id = +this.$route.params.id;
    await this.getService(id);
    this.selectedService = this.service;
    this.loading = false;
  },
  methods: {
    ...mapActions(["getService"]),
    makeToast(variant = null, body, title) {
      this.$bvToast.toast(body, {
        title,
        variant,
        solid: true,
        hide: true,
        autoHideDelay: 3000,
      });
    },
    postSaveForm() {
      const id = +this.$route.params.id;
      this.getService(id);
    },
  },
};
</script>
<style lang="scss" scoped>
#serviceDetailView {
  h3 {
    margin:10px;
  }
}
</style>